var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShippingboxicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 0H5.5V4.50756C5.5 4.63817 5.5554 4.76342 5.65401 4.85577C5.75262 4.94812 5.88637 5 6.02583 5H7.97417C8.11363 5 8.24738 4.94812 8.34599 4.85577C8.4446 4.76342 8.5 4.63817 8.5 4.50756V0ZM4.25 0H1.5C0.671573 0 0 0.671573 0 1.5V12.5C0 13.3284 0.671573 14 1.5 14H12.5C13.3284 14 14 13.3284 14 12.5V1.5C14 0.671573 13.3284 0 12.5 0H9.75V4.50756C9.75 4.99713 9.54158 5.44866 9.20043 5.76815C8.86205 6.08503 8.41965 6.25 7.97417 6.25H6.02583C5.58035 6.25 5.13795 6.08503 4.79957 5.76815C4.45842 5.44866 4.25 4.99714 4.25 4.50756V0ZM8.7594 11.0994C8.7594 10.7543 9.03922 10.4744 9.3844 10.4744H11.3978C11.743 10.4744 12.0228 10.7543 12.0228 11.0994C12.0228 11.4446 11.743 11.7244 11.3978 11.7244H9.3844C9.03922 11.7244 8.7594 11.4446 8.7594 11.0994Z",
    fill: "#CBCED4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingboxicon);
export default __webpack_public_path__ + "static/media/shippingboxicon.a60fc3548ff6ad6986b94eb85b79c04c.svg";
export { ForwardRef as ReactComponent };